module.exports = "<div class=\"brand-switcher\">\n    <a href=\"#\" ng-click=\"main.benjiLinkClick(false)\">Switch to Benji</a>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/common/topNav/popovers/brandSwitcher.html
// module id = 951
// module chunks = 1